import React from 'react';

interface StarsRatingProps {
    percentage: number;
    index: number;
}

import './stars-raitng.scss';

const StarsRating: React.FC<StarsRatingProps> = ({ percentage, index }) => {
    const formatPercentage = (percentage: number): string => {
        return percentage.toFixed(2).replace(/\.0+$/, '');
    };

    return (
        <li key={index} className="item">
            <div>
                {index}
            </div>
            <div className="item__icon" />
            <div className="item__line">
                <span style={{ width: `${formatPercentage(percentage)}%` }} />
            </div>
            <div className="item__percent">
                {formatPercentage(percentage)}
                {''}
                %
            </div>
        </li>
    );
};

export default StarsRating;
